// Swiped from: https://haensel.pro/javascript/vanilla-javascript-swipe-gesture-detection

/**
 * Manages swipe events.
 */
export default class Swiper {

    constructor() {
        this.touchStartX = 0;
        this.touchEndX = 0;
        this.minSwipePixels = 30;
        this.detectionZone = undefined;
        this.swiperCallback = function() {};
    }

    init(detectionZone, callback) {
        this.swiperCallback = callback;
        detectionZone.addEventListener('touchstart', event => {
            this.touchStartX = event.changedTouches[0].screenX;
        }, false);
        detectionZone.addEventListener('touchend', event => {
            this.touchEndX = event.changedTouches[0].screenX;
            this.handleSwipeGesture();
        }, false);
    }

    handleSwipeGesture() {
        let direction,
            moved;
        if (this.touchEndX <= this.touchStartX) {
            moved = this.touchStartX - this.touchEndX;
            direction = 'left';
        }
        if (this.touchEndX >= this.touchStartX) {
            moved = this.touchEndX - this.touchStartX;
            direction = 'right';
        }
        if (moved > this.minSwipePixels && direction !== 'undefined') {
            this.swipe(direction, moved);
        }
    }

    swipe(direction, movedPixels) {
        let ret = {};
        ret.direction = direction;
        ret.movedPixels = movedPixels;
        this.swiperCallback(ret);
    }

}
